import { Spinner } from '@ds';

export const RouteItemSpinner = () => (
  <div className="w-full flex flex-col items-center justify-center gap-4 p-3 h-56 bg-base-80 rounded-lg">
    <Spinner size="md" />
    <span className="text-s-sb text-base-20">Generating...</span>
  </div>
);
